import { Reveal, ClipReveal, Tag, LineReveal, ArrowLink } from "../components/Shared";
import { LATEST_EDIT } from "../data/content";

const LatestEdit = () => (
  <section className="relative bg-coal px-5 py-28 sm:px-10 md:py-40" data-testid="latest-edit-section">
    <div className="mx-auto max-w-[1600px]">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <Reveal><Tag>Signature Collection</Tag></Reveal>
          <LineReveal
            lines={["THE LATEST EDIT"]}
            className="mt-6 font-serif text-5xl font-light tracking-tight sm:text-6xl lg:text-7xl"
          />
          <Reveal delay={0.2}>
            <p className="mt-4 text-lg font-light text-fog">A new expression of the Rutu Bhonsle aesthetic.</p>
          </Reveal>
        </div>
        <Reveal delay={0.3}>
          <ArrowLink to="/collections" testId="latest-edit-view-all-link">View All Collections</ArrowLink>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-10 md:grid-cols-3 md:gap-8">
        {LATEST_EDIT.map((c, i) => (
          <div key={c.id} className={`group ${i === 1 ? "md:mt-20" : ""} ${i === 2 ? "md:mt-40" : ""}`} data-testid={`edit-card-${c.id}`}>
            <ClipReveal
              src={c.image}
              alt={`${c.name} — ${c.caption}`}
              delay={i * 0.12}
              className="aspect-[3/4]"
              imgClassName="transition-transform duration-[1.2s] ease-out group-hover:scale-110"
            />
            <Reveal delay={0.2 + i * 0.1}>
              <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.35em] text-flame">{c.season}</p>
              <h3 className="mt-2 font-serif text-3xl font-normal tracking-wide transition-colors duration-300 group-hover:text-flame">{c.name}</h3>
              <p className="mt-2 text-sm font-light italic text-fog">{c.caption}</p>
              <div className="mt-5">
                <ArrowLink to="/collections" testId={`edit-explore-${c.id}`}>Explore Collection</ArrowLink>
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default LatestEdit;
